import React, { useState } from "react";
import logo from "@assets/images/logo2.png";

const Footer = () => {
  const [showForm, setShowForm] = useState(false);

  const handleRequestDemo = () => {
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
  };

  return (
    <footer className="bg-zinc-950 gap-8 text-gray-400 py-12 px-6 sm:px-12 border-t border-gray-800 mt-20 relative">
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-8 text-sm">
        <div>
          <h4 className="text-white text-xl font-semibold mb-4 flex items-center gap-2">
            <img className="w-10 h-10" src={logo} alt="Logo" /> Zyntegrate
          </h4>
          <p>
            Integrate Anything. Empower Everything
          </p>
        </div>

        <div className="flex flex-col gap-4">
          {/* <button
            onClick={handleGetStarted}
            className="bg-indigo-600 hover:bg-indigo-500 text-white font-semibold py-2 px-6 rounded-lg transition"
          >
            Get Started
          </button> */}
          <button
            onClick={handleRequestDemo}
            className="bg-indigo-600 hover:bg-indigo-500 text-white font-semibold py-2 px-6 mt-3 rounded-lg transition border border-zinc-600"
          >
            Request Demo
          </button>
        </div>

        <div className="pl-8">
          <h4 className="text-white text-lg font-semibold mb-4">Contact</h4>
          <p>
            Email:{" "}
            <a
              href="mailto:support@zyntegrate.com"
              className="hover:text-white transition"
            >
              info@z-ninth.com
            </a>
          </p>
        </div>
      </div>

      <div className="text-center text-xs text-gray-600 mt-10">
        &copy; {new Date().getFullYear()} Zyntegrate. All rights reserved.
      </div>

      {showForm && (
  <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50">
    <div className="bg-white w-[90%] h-[90%] max-w-3xl rounded-2xl shadow-xl p-6 sm:p-10 flex flex-col relative">
      {/* Close button */}
      <button
        onClick={handleCloseForm}
        className="absolute top-5 right-5 text-gray-700 hover:text-black text-2xl"
      >
        ✕
      </button>

      {/* Center form content vertically */}
      <div className="flex-1 flex flex-col justify-center">
        <h3 className="text-2xl sm:text-3xl font-bold text-black mb-6 text-center">
          Request a Demo
        </h3>

        <form className="flex flex-col gap-4 w-full max-w-lg mx-auto">
          <input
            type="text"
            placeholder="Full Name"
            className="border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
          <input
            type="email"
            placeholder="Email Address"
            className="border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
          <textarea
            placeholder="Your Message"
            rows="5"
            className="border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
          <button
            type="submit"
            className="bg-indigo-600 hover:bg-indigo-500 text-white font-semibold py-3 px-6 rounded-lg transition"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  </div>
)}

    </footer>
  );
};

export default Footer;